module.exports = __webpack_public_path__ + "static/media/execute_subject_typeofQuestions.e13ed0a4.png";